<nts-loader
  [isVisible]="orchestratorViewModel.actionInProgress || !orchestratorViewModel.documentEnabled"
  [text]="loaderText"
  [animation]="loaderAnimation"
  [skipHeader]="false">
</nts-loader>

<div
  class="main-container"
  [class.has-header-bar]="!inIframe || showHeader"
  [ngClass]="orchestratorViewModel.customClasses">
  <form class="root-form layout-wide">
    <div class="layout-page layout-page-embedded">
      <div class="layout-gutter-left"></div>

      <div class="layout-content">
        <!-- header -->
        @if (orchestratorViewModel?.showPageHeader) {
          <nts-page-header
            [orchestratorViewModel]="orchestratorViewModel"
            [updateStatus]="updateStatus"
            (onUpdateStatusClicked)="showUpdateNotificationToast($event)">
          </nts-page-header>
        }

        <div class="layout-body">
          <div class="layout-gutter-left"></div>

          <div class="layout-content">
            <!-- sidebar sinistra (filtri/master)-->
            @if (viewModelLoaded && (isMasterDetail || hasSnapShotFeature)) {
              <div
                class="layout-aside-left layout-expandable"
              [@sideBarLeftOpenClose]="(
                                (orchestratorViewModel.eventDispatcher.onNavigationPanelVisibilityChanged$ | async)
                                    ? (orchestratorViewModel.eventDispatcher.onNavigationPanelCollapsed | async)
                                        ? 'closed'
                                        : (masterViewModel?.isFullScreen
                                            ? 'fullScreen'
                                            : 'open')
                                    : 'closed'
                            )">
                <nts-navigation-panel
                  class="navigation-panel"
                  (onMasterAreaSelected)="orchestratorViewModel.eventDispatcher.onMasterAreaSelected.next(true)"
                  (onSnapShotSelected)="orchestratorViewModel.eventDispatcher.onSnapShotSelected.next(true)"
                  (onNavigationPanelCollapsed)="orchestratorViewModel.eventDispatcher.onNavigationPanelCollapsed.next(true)"
                  [snapShotListViewModel]="snapShotListViewModel"
                  [masterViewModel]="masterViewModel"
                  [eventDispatcher]="orchestratorViewModel.eventDispatcher">
                </nts-navigation-panel>
              </div>
            }

            @if (showWingModalOverlay) {
              <div
                class="layout-aside-right__modal-overlay"
                [class.layout-aside-right__modal-overlay--beside-toolbar]="isWingDockBesideToolbar"
                [class.layout-aside-right__modal-overlay--transparent]="configurableWingViewModel?.modalOptions()?.isOverlayTransparent"
                [ngClass]="$safeNavigationMigration(configurableWingViewModel?.modalOptions()?.customOverlayClasses)"
                (click)="closeWingPanel()"
                aria-hidden="true">
              </div>
            }

            <div
              class="nts-content"
              [class.layout-collapsed]="masterViewModel?.isFullScreen">
              <!-- detail -->
              <div class="nts-content-header"
                [class.has-layout-aside-right]="viewModelLoaded && orchestratorViewModel.wingViewModel && isWingPushMode && isWingDockBesideToolbar">

                @if (viewModelLoaded && ((isMasterDetail && masterViewModel != null) || hasSnapShotFeature)) {
                  <div
                    class="aside-left-toggle-container"
                  [@sideBarLeftToggleVisibility]="(
                                        (orchestratorViewModel.eventDispatcher.onNavigationPanelVisibilityChanged$ | async)
                                            ? (
                                                (orchestratorViewModel.eventDispatcher.onNavigationPanelCollapsed | async)
                                                    ? 'visible'
                                                    : 'hidden'
                                            )
                                            : 'hidden'
                                    )">
                    <nts-text-button
                      (onClicked)="orchestratorViewModel.eventDispatcher.onNavigationPanelCollapsed.next(false)"
                      [icon]="'sidebar-expand'">
                    </nts-text-button>
                  </div>
                }

                <!-- toolbar -->
                <ng-container #toolbarContainer></ng-container>

                <!-- notification -->
                @if(viewModelLoaded && !(orchestratorViewModel.eventDispatcher.onNotificationBarCollapsed | async)) {
                  <nts-notification
                    [orchestratorViewModel]="orchestratorViewModel"
                    [class.has-layout-aside-right]="viewModelLoaded && orchestratorViewModel.wingViewModel && isWingPushMode"
                    [class.layout-aside-right-collapsed]="orchestratorViewModel.eventDispatcher.onWingCollapsed | async"
                    [style.--wing-width]="wingWidth"
                    [class.has-margin]="viewModelLoaded
                                        && (
                                            isMasterDetail
                                            || hasSnapShotFeature
                                        )
                                        && (orchestratorViewModel.eventDispatcher.onNavigationPanelCollapsed | async)
                                    ">
                  </nts-notification>
                }


                <!--validation -->
                @if (viewModelLoaded && !(orchestratorViewModel.eventDispatcher.onValidationBarCollapsed | async)) {
                  <nts-validation
                    [orchestratorViewModel]="orchestratorViewModel"
                    [class.has-layout-aside-right]="viewModelLoaded && orchestratorViewModel.wingViewModel && isWingPushMode"
                    [class.layout-aside-right-collapsed]="orchestratorViewModel.eventDispatcher.onWingCollapsed | async"
                    [style.--wing-width]="wingWidth"
                    [class.has-margin]="viewModelLoaded
                                        && (
                                            isMasterDetail
                                            || hasSnapShotFeature
                                        )
                                        && (orchestratorViewModel.eventDispatcher.onNavigationPanelCollapsed | async)
                                    ">
                  </nts-validation>
                }

              </div>

              <div class="nts-document-content"
                [class.has-tool-bar]="orchestratorViewModel?.showToolBar"
                [class.has-layout-aside-right]="viewModelLoaded && orchestratorViewModel.wingViewModel && isWingPushMode"
                [class.layout-aside-right-collapsed]="orchestratorViewModel.eventDispatcher.onWingCollapsed | async"
                [style.--wing-width]="wingWidth">

                <div class="layout-main scrollable-content"
                  [class.wing-closed]="orchestratorViewModel?.wingViewModel?.isCollapsed != null ? orchestratorViewModel.wingViewModel.isCollapsed : null"
                  [class.wing-opened]="orchestratorViewModel?.wingViewModel?.isCollapsed != null ? !orchestratorViewModel.wingViewModel.isCollapsed : null"
                  [class.layout-collapsed]="masterViewModel?.isFullScreen">

                  <div class="layout-gutter-left"></div>
                  <div class="layout-content document-placeholder-container">
                    <!-- detail content -->
                    <ng-template #documentPlaceHolder></ng-template>
                  </div>

                  <div class="layout-gutter-right"></div>
                </div>

                @if (viewModelLoaded && orchestratorViewModel.wingViewModel && !isWingDockBesideToolbar) {
                  <div
                    class="layout-aside-right"
                    [class.layout-collapsed]="isWingCollapsed"
                    [class.layout-aside-right--overlay]="isWingOverlayMode"
                    [class.layout-aside-right--modal]="isWingModal"
                    [class.layout-aside-right--push]="isWingPushMode"
                    [class.wing-animations-enabled]="wingAnimationsEnabled"
                    [style.--wing-width]="wingWidth">

                    <div class="layout-aside-right__panel">
                      <nts-wing-container
                        class="scrollable-content wing-scrollable-content"
                        [wingViewModel]="orchestratorViewModel.wingViewModel">
                      </nts-wing-container>
                    </div>

                    @if (showWingToggle) {
                      <button
                        #wingToggle
                        type="button"
                        class="wing-toggle"
                        (click)="toggleWingPanel()">
                        <svg-icon [key]="wingToggleIconKey"></svg-icon>
                      </button>
                    }
                  </div>
                }

              </div>
            </div>

            @if (viewModelLoaded && orchestratorViewModel.wingViewModel && isWingDockBesideToolbar) {
              <div
                class="layout-aside-right"
                [class.layout-collapsed]="isWingCollapsed"
                [class.layout-aside-right--beside-toolbar]="isWingDockBesideToolbar"
                [class.layout-aside-right--overlay]="isWingOverlayMode"
                [class.layout-aside-right--modal]="isWingModal"
                [class.layout-aside-right--push]="isWingPushMode"
                [class.wing-animations-enabled]="wingAnimationsEnabled"
                [style.--wing-width]="wingWidth">

                <div class="layout-aside-right__panel">
                  <nts-wing-container
                    class="scrollable-content wing-scrollable-content"
                    [wingViewModel]="orchestratorViewModel.wingViewModel">
                  </nts-wing-container>
                </div>

                @if (showWingToggle) {
                  <button
                    #wingToggle
                    type="button"
                    class="wing-toggle"
                    (click)="toggleWingPanel()">
                    <svg-icon [key]="wingToggleIconKey"></svg-icon>
                  </button>
                }
              </div>
            }
          </div>

          <div class="layout-gutter-right"></div>
        </div>
      </div>

      <div class="layout-gutter-right"></div>
    </div>
  </form>
</div>